export const instagramUrl = 'https://www.instagram.com/bright_digital_hubonline/'
export const checkoutUrl = 'https://complete-professional-myofascial-release-bundle.impultienda.ar/checkout'
export const offerAnchor = '#offer'
export const contactEmail = 'compradigitalyaa@gmail.com'

export const productName = 'Complete Professional Myofascial Release Bundle'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/qDT34uesRmduoJY73gqC3R/Caja_profesional_de_liberacion_miofascial_10_en_1.png'

export const bodyAreas = ['Cervical & Shoulder', 'Spine & Pelvis', 'Arm & Hand', 'Hip & Knee', 'Calf & Foot']

export const organizedNeeds = [
  { question: 'Neck, shoulder, and scapular techniques?', answer: "They're organized." },
  { question: 'Thoracic, lumbar, and pelvic references?', answer: "They're included." },
  { question: 'Arm, elbow, wrist, hand, hip, knee, and foot protocols?', answer: "They're covered." },
  { question: 'Complete clinical sessions with exercises and timing?', answer: "They're already structured." },
]

export const systemFlow = ['Select the region', 'Follow the technique', 'Integrate movement', 'Adapt to your patient']

export const showcaseFeatures = [
  '60 step-by-step soft-tissue techniques',
  '40 complete clinical session templates',
  'Patient positioning and hand-placement guidance',
  'Contact areas and directional instructions',
  'Functional rehabilitation exercises with sets and reps',
  '15- to 60-minute session formats',
  'Five additional professional toolkits',
  'Instant digital PDF access',
]

export type Volume = {
  number: string
  name: string
  intro: string
  items: string[]
  sessions: string
  tagline: string
}

export const volumes: Volume[] = [
  {
    number: '01',
    name: 'Cervical, Shoulder & Scapular Soft-Tissue Atlas',
    intro: '12 step-by-step techniques for the neck, upper back, shoulders, and scapular region.',
    items: ['Upper trapezius', 'Suboccipital region', 'Interscapular tissues', 'Posterior deltoid', 'Infraspinatus region', 'Lateral shoulder'],
    sessions: '+ 8 clinical sessions for neck rotation, scapular control, and shoulder reaching.',
    tagline: 'Locate. Position. Apply. Reassess.',
  },
  {
    number: '02',
    name: 'Thoracic, Lumbar & Pelvic Soft-Tissue Atlas',
    intro: '12 practical techniques for the thoracic back, lumbar region, and posterior pelvic musculature.',
    items: ['Thoracolumbar junction', 'Lumbar paraspinal muscles', 'Lumbar oblique tissues', 'Sacral-adjacent tissues', 'Central gluteal musculature', 'Posterior pelvic movement'],
    sessions: '+ 8 clinical sessions for sit-to-stand, trunk rotation, and walking tolerance.',
    tagline: 'Position. Apply. Move. Adapt.',
  },
  {
    number: '03',
    name: 'Arm, Elbow, Forearm, Wrist & Hand Soft-Tissue Atlas',
    intro: '12 step-by-step techniques for the upper limb, from the upper arm to the hand.',
    items: ['Biceps & triceps', 'Brachioradialis', 'Forearm extensors & flexors', 'Anconeus region', 'Thenar & hypothenar eminence', 'Dorsal hand soft tissues'],
    sessions: '+ 8 clinical sessions for forearm rotation, wrist function, and gripping.',
    tagline: 'Support. Locate. Apply. Integrate.',
  },
  {
    number: '04',
    name: 'Hip, Thigh & Knee Region Soft-Tissue Atlas',
    intro: '12 professional techniques for the hip, thigh, hamstrings, and regions surrounding the knee.',
    items: ['Rectus femoris', 'Vastus lateralis & medialis', 'Tensor fasciae latae region', 'Mid-thigh adductors', 'Medial & lateral hamstrings', 'Active knee extension'],
    sessions: '+ 8 clinical sessions for knee flexion, quadriceps activation, and controlled squatting.',
    tagline: 'Assess. Select. Organize.',
  },
  {
    number: '05',
    name: 'Calf, Ankle & Foot Soft-Tissue Atlas',
    intro: '12 step-by-step techniques for the lower leg, ankle region, and foot.',
    items: ['Medial & lateral gastrocnemius', 'Distal soleus region', 'Fibularis muscle region', 'Tibialis anterior', 'Medial plantar arch', 'Plantar forefoot'],
    sessions: '+ 8 clinical sessions for ankle movement, heel raises, balance, and walking.',
    tagline: 'Locate. Apply. Move. Reassess.',
  },
]

export const sampleMeta = [
  ['Main region', 'Hip, thigh & knee'],
  ['Primary objective', 'Controlled standing and weight transfer'],
  ['Total duration', '30 minutes'],
  ['Main reference', 'Volume 04'],
  ['Technique references', 'T02, T03 & T12'],
  ['Functional tasks', 'Supported weight shift and mini squat'],
] as const

export const sampleTimeline = [
  ['Confirm objective and record functional baseline', '4 min'],
  ['Vastus lateralis soft-tissue technique', '6 min'],
  ['Vastus medialis broad contact', '5 min'],
  ['Anterior thigh contact with active knee extension', '5 min'],
  ['Supported weight shifts and mini squats', '7 min'],
  ['Functional reassessment and documentation', '3 min'],
] as const

export const protocolStructure = [
  'Patient positioning',
  'Hand contact and direction',
  'Step-by-step execution',
  'Application timing',
  'Precautions',
  'Modifications',
  'Complementary exercises',
  'Functional reassessment',
]

export const differentiators = [
  {
    icon: 'book',
    title: 'Step-by-Step Techniques',
    text: '60 techniques organized by body region, with clear positioning and anatomical contact references.',
  },
  {
    icon: 'calendar',
    title: 'Clinical Session Templates',
    text: '40 structured sessions with objectives, techniques, active rehabilitation, and timing.',
  },
  {
    icon: 'activity',
    title: 'Manual Therapy + Active Rehab',
    text: 'Complementary exercises with sets, repetitions, rest periods, and progressions.',
  },
  {
    icon: 'clock',
    title: 'Less Preparation Time',
    text: 'Techniques, sessions, and patient resources together in one organized digital collection.',
  },
] as const
